import { Tag } from "antd";
import React from "react";

interface AiMappingConfidenceBadgeProps {
    confidence: number;
    className?: string;
}

const AiMappingConfidenceBadge: React.FC<AiMappingConfidenceBadgeProps> = ({ confidence, className = "" }) => {
    const getConfidenceLevel = (conf: number) => {
        if (conf >= 90) return { level: "High", color: "success" };
        if (conf >= 70) return { level: "Medium", color: "warning" };
        return { level: "Low", color: "error" };
    };

    const { level, color } = getConfidenceLevel(confidence);

    return (
        <Tag color={color} className={`ai-mapping-confidence-badge ${className}`}>
            AI Match {confidence}%
        </Tag>
    );
};

export default AiMappingConfidenceBadge;
